import React, { useState } from 'react'
import DefaultLayout from '../components/DefaultLayout'
import axios from 'axios'
import { NavLink } from 'react-router-dom'
import Select from 'react-select'
import { toast } from 'react-toast'
import styled from 'styled-components'

const Wrapper = styled.div`
	padding-bottom: 100px;
`

const Buttons = styled.div`
	display: flex;
	align-items: start;
	justify-content: space-between;
	margin-bottom: 24px;

	button {
		padding: 10px 16px;
		border-radius: 8px;
		font-size: 14px;
		font-weight: 600;
	}

	div {
		button {
			background: #fafafb;
    		color: #9e9ea7;
			margin-left: 16px;
		}
	}
`

const Load = styled.div`
	
`

const TitleArea = styled.input`
	font-size: 24px;
    font-weight: 700;
	margin-bottom: 30px;
	margin-top: 24px;
	padding-left: 40px;
	width: 100%;
	
	&::placeholder {
		color: #9E9EA7;
	}
`

const DragTitle = styled.span`
	color: #3d3d4e;
	font-size: 16px;
`

const SizeRec = styled.span`
	margin-top: 8px;
	color: #6e6d7a;
`

const ColoredBtn = styled.button`
	background: #aca2db !important;
	color: #fff !important;
`

const Cancel = styled.button`
	box-shadow: 0px 0px 0px 1px #e7e7e9 inset;
    color: #0d0c22;
`

const ImageLoader = styled.div`
	border: 2px dashed #e7e7e9;
    border-radius: 12px;
	padding: 110px 16px;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;

	img {
		width: 80px;
		margin-bottom: 12px;
	}
`

const ImageGrid = styled.ul`
	display: grid;
	grid-template-columns: 1fr 1fr;
	margin-top: 40px;

	li {
		list-style-position: inside;
    	list-style-type: disc;
		padding: 4px 24px;
		color: #6e6d7a;
	}
`

const options = [
	{ value: 'new', label: 'New' },
	{ value: '< 1 month', label: 'Less than 1 month' },
	{ value: '< 1 year', label: 'Less than 1 year' },
	{ value: '> 1 year', label: 'More than 1 year' },
	{ value: '< 5 years', label: 'More than 5 years' },
	{ value: 'ancient', label: 'Ancient' },
]

const PlaceProduct = () => {
	const [form, setForm] = useState({
		// image: '',
		// title: '',
		// description: '',
		// cost: 0,
		// manufacture: '',
		// series: '',
		// coreCount: 0,
		// socket: '',
		// seller: {
		//     name: 'Unknown',
		//     city: 'Kokshetau',
		// },
		// usage: '-',
		name: 'Nikita',
		sizes: {
			s: {
				count: 1,
			},
			m: {
				count: 1,
			},
			l: {
				count: 1,
			},
			xl: {
				count: 1,
			},
			xxl: {
				count: 1,
			},
		},
		code: '331233w4451231',
		feedbacks: [],
		bought: 123,
		color: 'red',
		images: [],
		seller: 512323,
		description: 'hello world',
		category: 'hel',
		price: 42312312344,
		properties: {
			content: 'cotton',
		},
	})

	const changeHandler = (event) => {
		setForm({ ...form, [event.target.name]: event.target.value })
	}

	const sendData = () => {
		axios
			.post('http://62.113.107.164:8080/products/new', { ...form })
			.then((response) => toast.info(response.data.msg))
			.catch((err) => toast.error(err))
	}

	return (
		<DefaultLayout>
			<Wrapper className="container">
				<form action="">
					<Buttons>
						<Cancel>
							Cancel
						</Cancel>
						<div>
							<button>Save</button>
							<ColoredBtn>Continue</ColoredBtn>
						</div>
					</Buttons>
					<TitleArea placeholder="Напишите название">
						
					</TitleArea>
					<Load>
						<ImageLoader>
							<img src="https://dribbble.com/assets/packs/media/assets/images/picture-placeholder-3b3bb1c9c8717331520e1d94512b3aed.png" alt="" />
							<DragTitle>
								Drag and drop an image, or Browse
							</DragTitle>
							<SizeRec>
								1600x1200 or higher recommended. Max 10MB each (20MB for videos)
							</SizeRec>
							<ImageGrid>
								<li>High resolution images (png, jpg, gif)</li>
								<li>Animated gifs (4:3, 800x600 - 1600x1200)</li>
								<li>Only upload media you own the rights to</li>
								<li>High resolution images (png, jpg, gif)</li>
							</ImageGrid>
						</ImageLoader>
					</Load>
				</form>
			</Wrapper>
		</DefaultLayout>
	)
}

export default PlaceProduct
